export function stripMarkdown(text) {
  if (!text) return '';
  return text
    .replace(/!\[.*?\]\(.*?\)/g, '')
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    .replace(/[#>*_~`|-]/g, '')
    .replace(/\n+/g, ' ')
    .trim();
}

export function getNewsExcerpt(text, maxLength = 200) {
  const plain = stripMarkdown(text);
  if (plain.length <= maxLength) return plain;
  return `${plain.slice(0, maxLength).trimEnd()}…`;
}
